// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Animações */

@keyframes slide-open-modal {
  from {
    transform: translateY(-100%);
    opacity: 0.5;
    display: none;
  }

  to {
    transform: translateY(0%);
    opacity: 1;
    display: flex;
  }
}

@keyframes slide-close-modal {
  from {
    transform: translateY(0%);
    opacity: 1;
    display: flex;

  }

  to {
    transform: translateY(-100%);
    opacity: 0.5;
    display: none;
  }
}

@keyframes slide-in-open {
  from {
    transform: translateX(-70%);
    opacity: 0;
    display: none;
    width: 0%;
  }

  to {
    transform: translateX(0);
    opacity: 1;
    display: flex;
    width: 100%;
  }
}

@keyframes slide-in-close {
  from {
    transform: translateX(0);
    opacity: 1;
    display: flex;
    width: 100%;
  }

  to {
    transform: translateX(-70%);
    opacity: 0;
    width: 0%;
    display: none;
  }
}

.openMenu{
  animation: slide-open-modal 0.3s forwards;
}

.closeMenu{
  animation: slide-close-modal 0.6s forwards;
}

.openModalEmail{
  animation: slide-in-open 0.3s forwards;
}

.closeModalEmail{
  animation: slide-in-close 0.3s forwards;
}

/* Header */
.proforma-header {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 0px 0px 20px 0px;
  background: var(--primary-background);
}

/* .button-filter-navbar{
  display: none;
} */

.modal-filter .box-overlay{
  z-index: 9;
}

.modal-email .box-overlay{
  z-index: 12;
}

.header-buttons {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  max-width: var(--max-width-desktop);
}
.icon-circle,
.icon-funnel-filter,
.icon-bolt-filter,
.icon-whitelabel {
  border-radius: 50%;
  border: 1px solid var(--primary-font);
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-whitelabel {
  color: var(--primary-font);
  padding: .3rem;
}

.icon-circle {
  border: 2px solid white;
}

::ng-deep .icon-funnel-filter svg{
  width: 16px !important;
}

::ng-deep .icon-bolt-filter svg{
  width: 13px !important;
  height: 20px !important;
}

.stroke {
  border-radius: 50%;
}

.proforma-logo {
  margin: 0 auto;
}

.icon-btn img {
  width: 32px;
}

mat-icon {
  width: 32px;
  height: 32px;
}

.email-input {
  margin-bottom: 20px;
  width: 100%;
  color: var(--text);
  border: 1px solid var(--text);
  background-color: var(--screen-background);
  padding: 5px;
  border-radius: 8px;
}

.email-input::placeholder {
  color: var(--filter);
}

.container-button-email {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.container-button-email button{
  height: 25px;
  width: 96px;
  font-size: 12px;
  align-items: center;
  color: var(--primary-font);
}

:host ::ng-deep .mat-raised-button.mat-primary {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 160px;
  height: 40px;
  border-radius: 100px;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
}

/* ABERTURA E FECHAMENTO DO MODAL DE EMAIL */
.openModalChange {
  visibility: visible;
}

.closeModalChange {
  visibility: hidden;
}

/* MODAL LOGIN */
.modal-login {
  background-color: var(--form-background);
  border-radius: 20px 0px 0px 0px;
  width: 100%;
  min-height: 264px;
  cursor: default;

}

.modal-login-wrapper{
  position: fixed;
  z-index: 15;
  max-width: 464px;
  margin: 0 auto;
  bottom: 0;
  left: 0;
  right: 0;
  padding-inline: 15px;
  transform: translateY(100%);
  transition: opacity 0.5s, visibility 0.5s;
}

.modal-login .modal-header {
  width: 100%;
  height: 72px;
  padding: 0;
  max-width: 464px;

  border: none;
  border-radius: 20px 0px 0px 0px;
  background-color: var(--primary-background);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.modal-login .modal-header .header-title {
  color: var(--primary-font);
  font-size: 20px;
  font-weight: 700;
  font-style: normal;
}

.modal-login .modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  padding: 20px;
}

.modal-login .modal-body p {
  max-width: 464px;
  color: var(--text);
  font-size: 14px;
  font-weight: 500;
  line-height: 16.41px;

  padding: 20px 40px 20px 40px;
}

.container-wall label {
  font-size: 0.88rem;
  margin-bottom: 0.3rem;
}

.bg-modal-email {
  align-items: flex-end;
}

.box-filter,
.box-header {
  border-radius: 0px 36px 0px 0px;
}

.box-filter {
  background-color: var(--screen-background);
  left: 0;
}

.box-header span {
  font-size: 32px;
}

.bg-modal-filter {
  justify-content: flex-start;
}

.button-link {
  background-color: var(--primary-background);
  width: 82.089px;
  height: 82.089px;
}

.menu-icon {
  width: 82.089px;
  height: 82.089px;
}

.criteria {
  width: 46.908px;
  height: 45.442px;
}

/* menu desktop */
.bg-modal-menu-desktop{
  position: fixed;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: transparent;
  bottom: 0;
  left: 0;
  z-index: 1;
  cursor: default;
  justify-content: center;
}

.container-modal-desktop{
  position: relative;
  height: 100%;
  width: 100%;
}

.link-menu-desktop {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* width: 316px; */
  cursor: pointer;
  padding: 10px 20px;
}

.link-menu-desktop:hover{
  background-color: var(--form-background);
  transition: background-color 0.5s;
}

.link-menu-desktop span{
  font-size: 16px;
  font-weight: 700;
  margin-left: 35px;
  color: var(--text);
}

.button-link-desktop {
  background-color: var(--primary-background);
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.menu-icon-desktop {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.next-icon{
  height: 20px;
  margin-left: 38px;
}

.modal-email-desktop{
  position: absolute;
  top: 56px;
  left: calc(15%);
  z-index: 4;
  min-height: 264px;
  background-color: var(--screen-background);
  border-radius: 0px 0px 20px 0px;
  border: 1px solid var(--text);
  border-top: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
}

.modal-body {
  padding: 0px;
}

.container-minhas-reformas-modal{
  position: absolute;
  z-index: 3;
  left: calc(15% + 260px);
  top: 56px;
  height: 264px;
  max-width: 48%;
  background-color: var(--form-background);
  border-radius: 0px 0px 20px 0px;
  border-left: 1px solid var(--text);
  border-bottom: 1px solid var(--text);
  border-right: 1px solid var(--text);
  overflow: hidden;
}

/* .container-minhas-reformas-modal.open{
  visibility: visible;
  animation: slide-in-open 0.3s;
}

.container-minhas-reformas-modal.close{
  animation: slide-in-close 0.3s;
} */

.container-content-modal-email{
  height: 100%;
  /* margin-left: 30px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 35px 25px 35px 55px;
  width: 100%;
  background-color: var(--form-background);
}


.header-title-desktop{
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 15px;
  color: var(--text);
}

.link-menu {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 50px;
  width: -moz-fit-content;
  width: fit-content;
  cursor: pointer;
}

.content-menu {
  margin-top: 120px;
  text-align: center;
  padding-left: 45.46px;
}

.link-menu span {
  font-size: 23.454px;
  font-weight: 700;
  margin-left: 30.79px;
  color: var(--text);
}

.botaoSuper{
  display: flex;
  justify-content: center;
  align-items: center;
  animation: tremer 2s infinite;
}
@keyframes tremer {
  0% { transform: translateX(0); }
  4% { transform: translateX(-0.3125rem); }
  8% { transform: translateX(0.3125rem); }
  12% { transform: translateX(-0.3125rem); }
  16% { transform: translateX(0); }
  100% { transform: translateX(0); }
}
@media (min-width: 1000px) {
  .container-minhas-reformas-modal{
    max-width: 480px;
  }
}

@media screen and (max-width: 767px) {

  .modal-filter{
    display: flex;
  }

  .bg-modal-menu-desktop,
  .container-modal-desktop
  {
    display: none;
  }

  .box-header{
    display: none;
  }

  .bg-modal-filter {
    padding: 0;
  }

  .box-filter {
    max-width: 450px;
    height: 100%;
  }

  .button-link,
  .menu-icon {
    width: 56px;
    height: 56px;
  }

  .criteria {
    width: 32px;
    height: 31px;
  }

  .link-menu span {
    font-size: 16px;
  }

  .icon-btn img {
    width: 32px;
  }

  mat-icon {
    width: 32px;
    height: 32px;
  }

}

@media (min-width: 768px) {

  .modal-filter{
    display: none;
  }

  .btn-left-mobile{
    display: none;
  }

  .proforma-logo img{
    margin-right: 0px;
  }

  .button-filter-navbar{
    display: block;
  }

  .proforma-header{
    z-index: 5;
  }
  .modal-login {
    min-height: 152px;
    border-radius: 20px;

  }

  .modal-login-wrapper{
    bottom: calc(50% - 76px);
    transform: none;
    transition: none;
    visibility: hidden;
  }

  .modal-login .modal-header {
    border-radius: 20px 20px 0px 0px;
  }

  .bg-modal-email {
    align-items: center;
  }

/*### ABERTURA E FECHAMENTO DO MODAL DE EMAIL SEM ANIMAÇÃO ### */
  .openModalChange{
    visibility: visible;
  }
  .openModalChange,
  .closeModalChange{
    animation: none;
  }
  /* ################################## */

  .header-buttons {
    max-width: 70%;
    padding: 0px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/app/shared/proforma-navbar/proforma-navbar.component.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE;IACE,4BAA4B;IAC5B,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,UAAU;IACV,aAAa;;EAEf;;EAEA;IACE,4BAA4B;IAC5B,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;IACV,aAAa;IACb,SAAS;EACX;;EAEA;IACE,wBAAwB;IACxB,UAAU;IACV,aAAa;IACb,WAAW;EACb;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,UAAU;IACV,aAAa;IACb,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,UAAU;IACV,SAAS;IACT,aAAa;EACf;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;;GAEG;;AAEH;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mCAAmC;AACrC;AACA;;;;EAIE,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,eAAe;;AAEjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,OAAO;EACP,QAAQ;EACR,oBAAoB;EACpB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;;EAEhB,YAAY;EACZ,+BAA+B;EAC/B,2CAA2C;;EAE3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;;EAEpB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,OAAO;AACT;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,SAAS;EACT,OAAO;EACP,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,0CAA0C;EAC1C,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,wCAAwC;EACxC,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;EACpC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;;;;;;;GAOG;;AAEH;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,wCAAwC;AAC1C;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,KAAK,wBAAwB,EAAE;EAC/B,KAAK,iCAAiC,EAAE;EACxC,KAAK,gCAAgC,EAAE;EACvC,MAAM,iCAAiC,EAAE;EACzC,MAAM,wBAAwB,EAAE;EAChC,OAAO,wBAAwB,EAAE;AACnC;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;IACE,aAAa;EACf;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;AAEF;;AAEA;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,mBAAmB;;EAErB;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;AAEF,gEAAgE;EAC9D;IACE,mBAAmB;EACrB;EACA;;IAEE,eAAe;EACjB;EACA,uCAAuC;;EAEvC;IACE,cAAc;IACd,YAAY;EACd;;AAEF","sourcesContent":["/* Animações */\n\n@keyframes slide-open-modal {\n  from {\n    transform: translateY(-100%);\n    opacity: 0.5;\n    display: none;\n  }\n\n  to {\n    transform: translateY(0%);\n    opacity: 1;\n    display: flex;\n  }\n}\n\n@keyframes slide-close-modal {\n  from {\n    transform: translateY(0%);\n    opacity: 1;\n    display: flex;\n\n  }\n\n  to {\n    transform: translateY(-100%);\n    opacity: 0.5;\n    display: none;\n  }\n}\n\n@keyframes slide-in-open {\n  from {\n    transform: translateX(-70%);\n    opacity: 0;\n    display: none;\n    width: 0%;\n  }\n\n  to {\n    transform: translateX(0);\n    opacity: 1;\n    display: flex;\n    width: 100%;\n  }\n}\n\n@keyframes slide-in-close {\n  from {\n    transform: translateX(0);\n    opacity: 1;\n    display: flex;\n    width: 100%;\n  }\n\n  to {\n    transform: translateX(-70%);\n    opacity: 0;\n    width: 0%;\n    display: none;\n  }\n}\n\n.openMenu{\n  animation: slide-open-modal 0.3s forwards;\n}\n\n.closeMenu{\n  animation: slide-close-modal 0.6s forwards;\n}\n\n.openModalEmail{\n  animation: slide-in-open 0.3s forwards;\n}\n\n.closeModalEmail{\n  animation: slide-in-close 0.3s forwards;\n}\n\n/* Header */\n.proforma-header {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 11;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  border-radius: 0px 0px 20px 0px;\n  background: var(--primary-background);\n}\n\n/* .button-filter-navbar{\n  display: none;\n} */\n\n.modal-filter .box-overlay{\n  z-index: 9;\n}\n\n.modal-email .box-overlay{\n  z-index: 12;\n}\n\n.header-buttons {\n  width: 100%;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 10px;\n  max-width: var(--max-width-desktop);\n}\n.icon-circle,\n.icon-funnel-filter,\n.icon-bolt-filter,\n.icon-whitelabel {\n  border-radius: 50%;\n  border: 1px solid var(--primary-font);\n  height: 32px;\n  width: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-whitelabel {\n  color: var(--primary-font);\n  padding: .3rem;\n}\n\n.icon-circle {\n  border: 2px solid white;\n}\n\n::ng-deep .icon-funnel-filter svg{\n  width: 16px !important;\n}\n\n::ng-deep .icon-bolt-filter svg{\n  width: 13px !important;\n  height: 20px !important;\n}\n\n.stroke {\n  border-radius: 50%;\n}\n\n.proforma-logo {\n  margin: 0 auto;\n}\n\n.icon-btn img {\n  width: 32px;\n}\n\nmat-icon {\n  width: 32px;\n  height: 32px;\n}\n\n.email-input {\n  margin-bottom: 20px;\n  width: 100%;\n  color: var(--text);\n  border: 1px solid var(--text);\n  background-color: var(--screen-background);\n  padding: 5px;\n  border-radius: 8px;\n}\n\n.email-input::placeholder {\n  color: var(--filter);\n}\n\n.container-button-email {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.container-button-email button{\n  height: 25px;\n  width: 96px;\n  font-size: 12px;\n  align-items: center;\n  color: var(--primary-font);\n}\n\n:host ::ng-deep .mat-raised-button.mat-primary {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  width: 160px;\n  height: 40px;\n  border-radius: 100px;\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n/* ABERTURA E FECHAMENTO DO MODAL DE EMAIL */\n.openModalChange {\n  visibility: visible;\n}\n\n.closeModalChange {\n  visibility: hidden;\n}\n\n/* MODAL LOGIN */\n.modal-login {\n  background-color: var(--form-background);\n  border-radius: 20px 0px 0px 0px;\n  width: 100%;\n  min-height: 264px;\n  cursor: default;\n\n}\n\n.modal-login-wrapper{\n  position: fixed;\n  z-index: 15;\n  max-width: 464px;\n  margin: 0 auto;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding-inline: 15px;\n  transform: translateY(100%);\n  transition: opacity 0.5s, visibility 0.5s;\n}\n\n.modal-login .modal-header {\n  width: 100%;\n  height: 72px;\n  padding: 0;\n  max-width: 464px;\n\n  border: none;\n  border-radius: 20px 0px 0px 0px;\n  background-color: var(--primary-background);\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-login .modal-header .header-title {\n  color: var(--primary-font);\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n.modal-login .modal-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  padding: 20px;\n}\n\n.modal-login .modal-body p {\n  max-width: 464px;\n  color: var(--text);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 16.41px;\n\n  padding: 20px 40px 20px 40px;\n}\n\n.container-wall label {\n  font-size: 0.88rem;\n  margin-bottom: 0.3rem;\n}\n\n.bg-modal-email {\n  align-items: flex-end;\n}\n\n.box-filter,\n.box-header {\n  border-radius: 0px 36px 0px 0px;\n}\n\n.box-filter {\n  background-color: var(--screen-background);\n  left: 0;\n}\n\n.box-header span {\n  font-size: 32px;\n}\n\n.bg-modal-filter {\n  justify-content: flex-start;\n}\n\n.button-link {\n  background-color: var(--primary-background);\n  width: 82.089px;\n  height: 82.089px;\n}\n\n.menu-icon {\n  width: 82.089px;\n  height: 82.089px;\n}\n\n.criteria {\n  width: 46.908px;\n  height: 45.442px;\n}\n\n/* menu desktop */\n.bg-modal-menu-desktop{\n  position: fixed;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  cursor: default;\n  justify-content: center;\n}\n\n.container-modal-desktop{\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\n.link-menu-desktop {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  /* width: 316px; */\n  cursor: pointer;\n  padding: 10px 20px;\n}\n\n.link-menu-desktop:hover{\n  background-color: var(--form-background);\n  transition: background-color 0.5s;\n}\n\n.link-menu-desktop span{\n  font-size: 16px;\n  font-weight: 700;\n  margin-left: 35px;\n  color: var(--text);\n}\n\n.button-link-desktop {\n  background-color: var(--primary-background);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n}\n\n.menu-icon-desktop {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.next-icon{\n  height: 20px;\n  margin-left: 38px;\n}\n\n.modal-email-desktop{\n  position: absolute;\n  top: 56px;\n  left: calc(15%);\n  z-index: 4;\n  min-height: 264px;\n  background-color: var(--screen-background);\n  border-radius: 0px 0px 20px 0px;\n  border: 1px solid var(--text);\n  border-top: none;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 5px;\n}\n\n.modal-body {\n  padding: 0px;\n}\n\n.container-minhas-reformas-modal{\n  position: absolute;\n  z-index: 3;\n  left: calc(15% + 260px);\n  top: 56px;\n  height: 264px;\n  max-width: 48%;\n  background-color: var(--form-background);\n  border-radius: 0px 0px 20px 0px;\n  border-left: 1px solid var(--text);\n  border-bottom: 1px solid var(--text);\n  border-right: 1px solid var(--text);\n  overflow: hidden;\n}\n\n/* .container-minhas-reformas-modal.open{\n  visibility: visible;\n  animation: slide-in-open 0.3s;\n}\n\n.container-minhas-reformas-modal.close{\n  animation: slide-in-close 0.3s;\n} */\n\n.container-content-modal-email{\n  height: 100%;\n  /* margin-left: 30px; */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 35px 25px 35px 55px;\n  width: 100%;\n  background-color: var(--form-background);\n}\n\n\n.header-title-desktop{\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 15px;\n  color: var(--text);\n}\n\n.link-menu {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-bottom: 50px;\n  width: fit-content;\n  cursor: pointer;\n}\n\n.content-menu {\n  margin-top: 120px;\n  text-align: center;\n  padding-left: 45.46px;\n}\n\n.link-menu span {\n  font-size: 23.454px;\n  font-weight: 700;\n  margin-left: 30.79px;\n  color: var(--text);\n}\n\n.botaoSuper{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: tremer 2s infinite;\n}\n@keyframes tremer {\n  0% { transform: translateX(0); }\n  4% { transform: translateX(-0.3125rem); }\n  8% { transform: translateX(0.3125rem); }\n  12% { transform: translateX(-0.3125rem); }\n  16% { transform: translateX(0); }\n  100% { transform: translateX(0); }\n}\n@media (min-width: 1000px) {\n  .container-minhas-reformas-modal{\n    max-width: 480px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n\n  .modal-filter{\n    display: flex;\n  }\n\n  .bg-modal-menu-desktop,\n  .container-modal-desktop\n  {\n    display: none;\n  }\n\n  .box-header{\n    display: none;\n  }\n\n  .bg-modal-filter {\n    padding: 0;\n  }\n\n  .box-filter {\n    max-width: 450px;\n    height: 100%;\n  }\n\n  .button-link,\n  .menu-icon {\n    width: 56px;\n    height: 56px;\n  }\n\n  .criteria {\n    width: 32px;\n    height: 31px;\n  }\n\n  .link-menu span {\n    font-size: 16px;\n  }\n\n  .icon-btn img {\n    width: 32px;\n  }\n\n  mat-icon {\n    width: 32px;\n    height: 32px;\n  }\n\n}\n\n@media (min-width: 768px) {\n\n  .modal-filter{\n    display: none;\n  }\n\n  .btn-left-mobile{\n    display: none;\n  }\n\n  .proforma-logo img{\n    margin-right: 0px;\n  }\n\n  .button-filter-navbar{\n    display: block;\n  }\n\n  .proforma-header{\n    z-index: 5;\n  }\n  .modal-login {\n    min-height: 152px;\n    border-radius: 20px;\n\n  }\n\n  .modal-login-wrapper{\n    bottom: calc(50% - 76px);\n    transform: none;\n    transition: none;\n    visibility: hidden;\n  }\n\n  .modal-login .modal-header {\n    border-radius: 20px 20px 0px 0px;\n  }\n\n  .bg-modal-email {\n    align-items: center;\n  }\n\n/*### ABERTURA E FECHAMENTO DO MODAL DE EMAIL SEM ANIMAÇÃO ### */\n  .openModalChange{\n    visibility: visible;\n  }\n  .openModalChange,\n  .closeModalChange{\n    animation: none;\n  }\n  /* ################################## */\n\n  .header-buttons {\n    max-width: 70%;\n    padding: 0px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
